'use strict';

export function initHoverTitle(selector, context, delay = 500) {
    /*
    on mouseenter palaižam taimeri un saglabājam kuram elementam tas ir;
    on mouseleave apturam taimeri un nodzēšam elementu;
    */
    var hoverTimer = null;
    var hoverElement = null;
    var hoverFixed = false;
    var hoverClicked = false;
    var leftOff;
    var leftWidth;
    var leftMax;
    const hoverTimerDelay = delay;
    const offsetX = 10;
    const $toolTip = $('<div class="statTooltip"></div>').css({
        display: 'block',
        opacity: 0.5,
        top: '-30px',
        left: '-30px',
        zIndex: -1
    }).appendTo('body');

    const toolTipGetHTML = function ($el) {
        return '<span class="tt">' + $el.data('title') + '</span>';
    };
    const getFixedLeft = function (left) {
        leftWidth = $toolTip.outerWidth();
        return left + leftWidth > $(window).width() ? left - leftWidth - (15 + offsetX) : left;
    };
    const show = function () {
        leftOff = $toolTip.offset().left;
        leftWidth = $toolTip.outerWidth();
        leftMax = leftOff + leftWidth;

        if (leftMax > $(window).width()) {
            leftMax = leftOff - leftWidth - (15 + offsetX);
            $toolTip.css({
                left: leftMax + 'px'
            });
        }
        $toolTip.css({
            opacity: 1,
            zIndex: 1000
        });
    };
    const hide = function () {
        $toolTip.css({
            opacity: 0,
            zIndex: -1
        });
    };
    const hideOther = function () {
        $('.statTooltip').not($toolTip).css({
            opacity: 0,
            zIndex: -1
        });
    };

    $(context).on('mouseenter', selector, function () {
        if (hoverClicked) {
            return;
        }
        hoverElement = this;
        $toolTip.html(toolTipGetHTML($(this)));
        hoverTimer = setTimeout(() => {
            hoverFixed = true;
            hideOther();
            show();
        }, hoverTimerDelay);
    }).on('mouseleave', selector, function () {
        if (hoverClicked) {
            return;
        }
        clearTimeout(hoverTimer);
        hoverElement = null;
        hoverFixed = false;
        hide();
    }).on('mousemove', selector, function (event) {
        if (hoverFixed || hoverClicked) {
            return;
        }
        $toolTip.css({
            top: event.pageY + 5,
            left: getFixedLeft(event.pageX + 5 + offsetX)
        });
    }).on('click', selector, function (event) {
        if ($(this).data('nottclick')) {
            return;
        }

        event.stopPropagation();

        hoverClicked = true;
        hoverFixed = true;
        if (hoverElement !== this) {
            hoverElement = this;
            $toolTip.html(toolTipGetHTML($(this)));
        }
        $toolTip.css({
            top: event.pageY + 5,
            left: getFixedLeft(event.pageX + 5 + offsetX)
        });
        hideOther();
        show();
    });

    $(document).on('hideHovers', function () {
        hoverClicked = false;
        hoverFixed = false;
        hide();
    });

    $(window).on('jq-outclick', function (event) {
        if (hoverClicked) {
            hoverClicked = false;
            hoverFixed = false;
            hide();
        }
    });
}

